export default {
    firebase: {
        apiKey: "AIzaSyAw-WImOsu1lZSyJlNcqcAJEjs-g_xMOXc",
        authDomain: "true-facts-nz.firebaseapp.com",
        databaseURL: "https://true-facts-nz.firebaseio.com",
        messagingSenderId: "590715290066",
        projectId: "true-facts-nz",
        storageBucket: "true-facts-nz.appspot.com",
    }
}


// WEBPACK FOOTER //
// ./src/config.js